export default __webpack_public_path__ + "static/media/b2.1e81de14.jpg";